<template>
    <main-content>
        <kt-panel>
            <kt-panel-body v-if="is_current_user_fetched">
                <div v-if="$can('update-info', 'card-to-card-gateway')">
                    <manage-details></manage-details>
                </div>
                <div v-else>
                    <common-details></common-details>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {mapGetters} from 'vuex'
import manageDetails from './components/manage-details'
import commonDetails from './components/common/details'

export default {
    components: {
        mainContent,
        manageDetails,
        commonDetails,
    },
    computed: {
        ...mapGetters('user', [
            'current_user', 'is_current_user_fetched'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
        }
    },
}
</script>

<style>
@media (min-width: 768px) {
    #ivr-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>